const getCurrentBaseUrl = () => {
  const origin = window.location.origin;
  return origin;
};

const workerCode = `
  importScripts('https://cdnjs.cloudflare.com/ajax/libs/axios/1.6.2/axios.min.js');
  let BASE_URL;

  async function decryptToken(token) {
    if (!BASE_URL) {
      throw new Error('BASE_URL not initialized');
    }

    try {
      const response = await axios.post(\`\${BASE_URL}/api/recipient-dashboard/token\`, {
        token: token
      }, {
        timeout: 5000,
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.data.success) {
        throw new Error(response.data.error);
      }

      return response.data.payload.payload;
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message);
    }
  }

  self.onmessage = async function(e) {
    // If this is the initialization message
    if (e.data.type === 'init') {
      BASE_URL = e.data.baseUrl;
      self.postMessage({ type: 'initialized' });
      return;
    }

    try {
      const decryptedData = await decryptToken(e.data);
      self.postMessage({ type: 'result', success: true, data: decryptedData });
    } catch (error) {
      self.postMessage({ type: 'result', success: false, error: error.message });
    }
  };
`;

const workerBlob = new Blob([workerCode], { type: 'application/javascript' });
const workerUrl = URL.createObjectURL(workerBlob);

export class TokenDecryptWorker {
  private worker: Worker;
  private initPromise: Promise<void>;

  constructor() {
    this.worker = new Worker(workerUrl);
    this.initPromise = this.initializeWorker();
  }

  private initializeWorker(): Promise<void> {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        reject(new Error('Worker initialization timeout'));
      }, 5000);

      const messageHandler = (e: MessageEvent) => {
        if (e.data.type === 'initialized') {
          clearTimeout(timeout);
          this.worker.removeEventListener('message', messageHandler);
          resolve();
        }
      };

      this.worker.addEventListener('message', messageHandler);
      const baseUrl = getCurrentBaseUrl();
      this.worker.postMessage({ type: 'init', baseUrl });
    });
  }

  async decrypt(token: string): Promise<any> {
    try {
      await this.initPromise;

      return new Promise((resolve, reject) => {
        const messageHandler = (e: MessageEvent) => {
          if (e.data.type === 'result') {
            this.worker.removeEventListener('message', messageHandler);
            if (e.data.success) {
              resolve(e.data.data);
            } else {
              reject(new Error(e.data.error));
            }
          }
        };

        this.worker.addEventListener('message', messageHandler);
        this.worker.postMessage(token);
      });
    } catch (error: any) {
      throw new Error(`Decryption failed: ${error.message}`);
    }
  }

  terminate() {
    this.worker.terminate();
    URL.revokeObjectURL(workerUrl);
  }
}